module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    attrs: {
      "model": _vm.formItem,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "需求名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formItem.input),
      callback: function($$v) {
        _vm.formItem.input = $$v
      },
      expression: "formItem.input"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formItem.select),
      callback: function($$v) {
        _vm.formItem.select = $$v
      },
      expression: "formItem.select"
    }
  }, [_c('Option', {
    attrs: {
      "value": "beijing"
    }
  }, [_vm._v("北京市")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "shanghai"
    }
  }, [_vm._v("上海市")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "shenzhen"
    }
  }, [_vm._v("深圳市")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "等级"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formItem.select),
      callback: function($$v) {
        _vm.formItem.select = $$v
      },
      expression: "formItem.select"
    }
  }, [_c('Option', {
    attrs: {
      "value": "beijing"
    }
  }, [_vm._v("北京市")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "shanghai"
    }
  }, [_vm._v("上海市")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "shenzhen"
    }
  }, [_vm._v("深圳市")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "期望日期"
    }
  }, [_c('Date-picker', {
    staticClass: "full-width",
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.formItem.date),
      callback: function($$v) {
        _vm.formItem.date = $$v
      },
      expression: "formItem.date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "背景说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formItem.input),
      callback: function($$v) {
        _vm.formItem.input = $$v
      },
      expression: "formItem.input"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "研发答复"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formItem.input),
      callback: function($$v) {
        _vm.formItem.input = $$v
      },
      expression: "formItem.input"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-39d0b68f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/requirement/components/Add.vue
// module id = 13
// module chunks = 0